export default "__VITE_PUBLIC_ASSET__c4587cce__"